export class TornadoBanner {
  private el: HTMLDivElement;
  private defaultText = '⚠ WARNING — TAKE SHELTER';
  constructor(parent: HTMLElement) {
    this.el = document.createElement('div');
    this.el.className = 'tornado-banner';
    this.el.textContent = this.defaultText;
    parent.append(this.el);
    this.hide();
  }
  setText(text: string): void {
    this.el.textContent = text || this.defaultText;
  }
  show(): void { this.el.style.display = ''; }
  hide(): void { this.el.style.display = 'none'; }
}
